var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vuestic-layout",
    { directives: [{ name: "layout", rawName: "v-layout" }] },
    [
      _c("app-navbar", {
        attrs: { isOpen: _vm.opened },
        on: { "toggle-menu": _vm.toggleSidebar },
      }),
      _c("app-sidebar", {
        attrs: { isOpen: _vm.showMenu },
        on: { "toggle-menu": _vm.toggleSidebar },
      }),
      _c(
        "main",
        {
          staticClass: "content va-layout gutter--lg fluid",
          staticStyle: { "padding-top": "0" },
          attrs: { slot: "content", id: "content", role: "main" },
          slot: "content",
        },
        [
          _c("app-breadcrumbs"),
          _c("router-view"),
          _c(
            "div",
            { staticClass: "business-manager-fix" },
            [_c("business-manager")],
            1
          ),
        ],
        1
      ),
      _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          {
            staticClass: "va-row",
            staticStyle: { "text-align": "center", "margin-top": "3rem" },
          },
          [
            _vm.VUE_APP_DOCS
              ? _c(
                  "div",
                  { class: `flex ${_vm.VUE_APP_TERMS ? "md4" : "md6"}` },
                  [
                    _c(
                      "a",
                      { attrs: { target: "_blank", href: _vm.VUE_APP_DOCS } },
                      [_vm._v(_vm._s(_vm._f("translate")("t.docs")))]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.VUE_APP_PRIVACY
              ? _c(
                  "div",
                  { class: `flex ${_vm.VUE_APP_TERMS ? "md4" : "md6"}` },
                  [
                    _c(
                      "a",
                      {
                        attrs: { target: "_blank", href: _vm.VUE_APP_PRIVACY },
                      },
                      [_vm._v(_vm._s(_vm._f("translate")("t.privacy")))]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.VUE_APP_TERMS
              ? _c("div", { staticClass: "flex md4" }, [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: _vm.VUE_APP_TERMS } },
                    [_vm._v(_vm._s(_vm._f("translate")("t.terms")))]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "va-row",
            staticStyle: { "text-align": "center", "margin-top": "1rem" },
          },
          [
            _c("p", { staticStyle: { "padding-top": "5px" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("t.copyrightPagsmile1")) +
                  " " +
                  _vm._s(` ${new Date().getFullYear()} ${_vm.VUE_APP_NAME}`) +
                  " " +
                  _vm._s(_vm._f("translate")("t.copyrightPagsmile2")) +
                  "\n      "
              ),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }